import React from "react";
import MonthlyTimeTable from "../MonthlyTimeTable";

const MarchSehriIftaar = ({districtDetails}) => {
  return <MonthlyTimeTable month={3} title="March Sehri Iftar" columnKey="3Columns" districtDetails={districtDetails} />;
};

export default MarchSehriIftaar;
